import "./Loader.css";

const Loader = () => {
  return (
    <div className="loaderdiv">
      <span class="loader"></span>
    </div>
  );
};

export default Loader;

const SwitchLoader = () => {
  return <div class="switch"></div>;
};
export { SwitchLoader };
